var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome3R({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 834,
    height: 543,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#fae89a",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7B568",
    d: "M165.224 253.962c-3.235 4.183-5.044 9.411-7.042 14.259-1.999 4.847-3.236 9.981-3.902 15.304-.666 5.228-1.523 10.646-.857 15.874.667 5.228 1.618 10.742 3.617 15.59 1.713 4.182 4.473 8.365 5.805 12.737 1.428 4.658 1.618 8.746-.571 13.118-2.855 5.513-7.709 9.601-13.133 12.548-4.759 2.661-9.041 5.798-12.848 9.696-3.807 3.992-8.185 7.604-10.278 12.642-2.094 5.038-3.426 10.742-3.141 16.255.286 5.513 2.95 10.551 5.996 15.209 3.426 5.228 7.613 10.361 13.038 13.498 5.234 2.947 11.42 4.563 17.416 5.894 5.996 1.33 12.086.475 17.987-.286 5.996-.76 11.991-1.711 17.225-4.943 5.14-3.136 8.375-8.269 11.421-13.403 3.045-5.228 6.281-10.646 6.566-16.539.286-5.989-1.427-12.073-4.758-17.301-2.95-4.658-8.185-8.365-11.611-12.833-3.806-4.943-5.519-10.741-3.711-16.54 1.332-4.467 4.853-8.079 8.47-11.026 3.711-3.042 7.423-6.084 11.23-9.031 3.711-3.041 7.708-5.703 11.42-8.745 4.663-3.802 9.422-7.89 13.609-12.167 4.283-4.373 8.09-9.126 10.659-14.734 2.189-4.753 2.094-9.886 2.189-15.114.095-5.133.19-10.266-1.618-15.114-1.713-4.943-4.949-8.84-8.28-12.833-3.33-3.992-5.9-9.125-10.468-11.502-5.33-2.851-11.706-2.566-17.606-2.661-5.806 0-11.897.19-17.512 2.281-5.615 1.996-11.325 4.373-16.178 7.795-4.949 3.232-9.708 7.509-13.134 12.072Z",
    style: {
      fill: "#fae89a",
      fillOpacity: 1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M155.003 328.107c6.281 6.939 17.987 8.079 25.41 2.376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "m190.406 294.551-.287 57.035-20.65-3.078M190.406 310.711c4.758 10.932 21.413 7.605 24.744.922M150.435 367.745s20.937 6.179 38.067 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D096FE",
    d: "M578.731 256.487c22.285 7.031 43.111 28.882 50.142 44.463 10.479 22.896 15.653 67.263-19.5 81.324-15.122 5.986-38.07 5.035-52.662-1.52-21.622-9.595-26.397-32.777-30.51-49.213-5.173-20.141-6.765-42.182 7.296-60.708 13-17.101 29.449-19.381 45.234-14.346Z",
    style: {
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M557.276 242.814c-5.849 24.088-11.596 48.175-17.446 72.161 5.747.307 11.494.717 17.343 1.025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M574.003 291.502c-1.642-12.608-9.338-18.758-18.266-14.555M550.708 268.337c-.718-3.588-3.592-6.663-7.183-7.585-3.592-.923-7.594.205-10.057 2.972M572.361 319.587c-7.266 10.221-21.933 8.188-31.915 3.895"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M242.763 395.203c19.547 7.611 43.843 2.023 57.758-11.947 12.258-12.332 12.921-30.444 15.682-45.955 3.754-21.388 8.503-73.413 45.83-68.596 31.474 4.046 27.499 43.354 27.94 63.104.442 17.824 6.626 65.609 39.205 58.287 7.841-1.734 12.148-9.249 13.031-16.282 2.209-17.919-3.092-37.091-1.325-55.589.994-10.501 7.289-24.278 20.21-27.072 20.54-4.432 24.737 17.438 25.179 29.866.441 10.79 3.423 24.085 15.35 27.265"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACF6E4",
    d: "M414.447 354.901c-10.028 2.922-19.4 11.845-22.564 18.235-4.716 9.391-7.044 27.587 8.775 33.354 6.805 2.455 17.132 2.065 23.698-.624 9.73-3.935 11.879-13.442 13.729-20.183 2.328-8.261 3.045-17.3-3.283-24.898-5.85-6.975-13.252-7.949-20.355-5.884Z",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#f4e2e2",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFECE7",
    d: "M453.208 285.595c-3.258-.31-6.67.155-9.928 1.394-9.359 3.667-13.909 12.757-14.788 22.26-.414 4.545-.052 9.349 2.223 13.274 5.326 9.193 16.96 9.968 25.802 5.784 11.118-5.268 14.427-16.424 12.772-28.096-1.241-8.728-8.221-13.893-16.081-14.616Z",
    style: {
      fill: "#f4e2e2",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#e6abab",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFBABA",
    d: "M310.074 311.301c-1.805-2.842-3.707-5.913-4.313-10.193-1.655-11.694 1.25-28.464 17.964-24.435 5.742.929 7.147 11.058 9.111 15.036 2.261 4.578 4.812 9.691 10.545 7.392 2.95-1.183 5.853-3.562 9.082-3.828 4.652-.384 8.002.16 12.464 1.899 8.626 3.361 8.662 17.432 2.891 23.452-10.103 10.538-25.964 9.834-38.509 5.055-7.669-2.922-14.781-7.364-19.235-14.378Z",
    style: {
      fill: "#e6abab",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#EFF3EE",
    strokeWidth: 5,
    d: "M666.338 170.355c10.662-26.32 37.847-39.505 60.358-30.374 10.947 4.44 17.694 12.174 19.043 21.104 1.351 8.936-2.584 19.863-14.719 30.884a7.865 7.865 0 0 0-1.453 9.842c6.143 10.267 7.657 17.718 6.684 22.946-.944 5.074-4.339 8.58-9.426 10.808-5.152 2.255-11.869 3.098-18.832 2.754-6.942-.342-13.911-1.853-19.47-4.108-22.511-9.131-32.848-37.535-22.185-63.856Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AB87",
    d: "M824.094 298.522c-.162.965.135 6.064-11.008 31.42-6.853 15.594-26.429 32.395-42.893 41.541-10.306 5.725-17.994 6.157-24.908 8.513 2.749-10.703 7.3-21.148 13.522-32.131 8.962-15.819 21.671-29.509 25.615-32.794 6.683-5.566 39.833-17.514 39.672-16.549Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M668 359c-15.533 12.982-39.247 13-35.363 38.835 2 14.736 28.69 12.302 26.466 23.51-.83 4.076-5.09 6.151-8.785 7.887-8.369 3.925-16.437 9.397-21.301 17.473-4.863 8.076-5.73 19.208-.264 26.869 7.465 10.415 32.423 12.845 47.416 22.623 18.05 11.772 21.829 33.794 21.829 33.794l27.765.509s7.249-24.434 15.474-31.718c17.507-15.504 47.973-26.793 53.025-33.624 5.089-6.792 6.032-16.415 3.053-24.416-2.978-8-9.727-14.264-17.531-17.17-4.901-1.849-10.971-3.057-13.044-8.001-2.903-6.83 12.818-13.019 16.475-16.264 6.711-5.887 5.806-14.869 1.433-21.888-5.165-8.302-13.761-8.34-20.585-14.416-10.368-9.208-22.244-18.868-27.937-31.737-4.863-10.981-16.739-18.189-28.389-17.17-23.37 2.027-23.849 31.628-39.737 44.904Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1F9A2",
    d: "M97.182 203.479c3.573 4.441 51.974-7.704 53.81-11.709.482-30.048 4.229-89.14 4.722-119.157a15391.094 15391.094 0 0 0-33.864 5.227c-2.743 14.006-5.467 27.971-8.211 41.977L95.144 71.714c-9.826 2.19-19.641 4.41-29.497 6.612 2.618 12.327 5.236 24.655 7.866 37.012a28926.66 28926.66 0 0 0-20.627-30.593c-6.802 6.32-13.634 12.651-20.465 18.982 2.909 5.22 48.77 74.878 64.761 99.752Z",
    style: {
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#64E986",
    d: "m200.039 70.328 5.423-3.305 5.308-3.634 4.273-4.8 4.568-5.804 4.556-5.768 4.473-5.74 2.805-6.575 2.79-6.072-6.425-1.353-7.225.392-7.212.355-5.964 2.68-6.1 2.077-5.974 2.484-7.46 5.176-5.532 7.253-3.528 6.389-2.356 6.68-1.679 6.783-.646 6.704.129 6.51 4.767-.528 7.256-2.408 7.016-3.377 6.737-4.119Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M193.025 105.8c-33.89-11.03-61.236 48.831-71.582 72.335-10.064 22.91-18.242 47.13-44.302 55.29-23.07 7.169-63.142.805-73.141 30.015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome3R);
export default __webpack_public_path__ + "static/media/bg_home3_r.990a24b6150d720c948fdae979ee4fd9.svg";
export { ForwardRef as ReactComponent };